import styled from 'styled-components';
import endPoints from '../../config/endPoints';

const StyledPayRollCardContactUs = styled.div`
  .bd-radius-50{
    border-radius: 50px;
  }
  hr{
    width: 6%;
    height: 3px;
    border: none;
    background-color: ${(props) => props.theme.primaryColor};
  }
  .form-bg{
    background:${(props) => props.theme.whiteColor};
    box-shadow: 0 0 10px rgba(0.2, 1, 5, 0.5);
    padding: 15px 30px 10px 30px;
    border-radius: 4px;
    .ant-form-item{
      margin-bottom: 4px;
      .ant-form-item-label{
        padding-bottom: 0;
        &::after{
          content: '*';
          color: ${(props) => props.theme.primaryColor};
        }
      }
      .ant-input{
        box-shadow: none !important;
        height: 40px;
        border: 1px solid ${(props) => props.theme.webGray};
        font-size: 14px;
        background: ${(props) => props.theme.tintGray};
      }
    }
  }
  .employee-happy{
    background: url(${endPoints.SAVE_SMALL_BACKGROUND_LOGO.URL}) no-repeat;
    background-position: center;
    background-size: 100%;
    background-color: ${(props) => props.theme.whiteColor};
    hr{
      float: left;
    }
    .card-padding-10{
      height: 160px;
      margin-bottom: 20px;
      border-radius: 14px;
      box-shadow: 0px 0px 5px 8px rgb(70 65 65 / 5%);
      .ant-card-body{
        padding: 10px;
        img{
          padding-top: 20px;
          width: 40%;
          @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
          padding-top: 0px;
          width: 20%;
          };
        }
      }
    }
  }
  .simple-steps{
    background-color: ${(props) => props.theme.whiteColor};
    img{
      width: 20%;
      background: ${(props) => props.theme.lightWhite};
      border-radius: 25%;
      padding: 8px
    }
  }
`;
export default StyledPayRollCardContactUs;



// WEBPACK FOOTER //
// client/containers/PayRollCardContact/StyledPayRollCardContactUs.js